import React from 'react'
import { Text } from '@chilipiper/design-system'
import { rolloutFlags } from '@chilipiper/rollout'
import { AppearanceSettings } from '../api-queries/botAndDataFieldsVisibilitySettings'

const renderTextWithLinks = (content: AppearanceSettings['consentFooter']) => {
  const { text, links } = content

  if (!links?.length) {
    return text
  }

  // Find all link positions and sort by occurrence
  const linkPositions = links
    .map(link => ({ ...link, position: text.indexOf(link.text) }))
    .filter(link => link.position !== -1)
    .sort((a, b) => a.position - b.position)

  if (!linkPositions.length) {
    return text
  }

  // Split text into segments and replace with links
  const segments: React.ReactNode[] = []
  let lastIndex = 0

  linkPositions.forEach((link, index) => {
    // Add text before link
    if (link.position > lastIndex) {
      segments.push(text.substring(lastIndex, link.position))
    }

    // Add link
    segments.push(
      <Text
        key={`link-${index}`}
        as='a'
        target='_blank'
        href={link.url}
        color='fg/moderate'
        textStyle='detail-s'
        textDecoration='underline'
      >
        {link.text}
      </Text>
    )

    lastIndex = link.position + link.text.length
  })

  // Add remaining text
  if (lastIndex < text.length) {
    segments.push(text.substring(lastIndex))
  }

  return segments
}

interface ConsentFooterProps {
  consentFooter?: AppearanceSettings['consentFooter']
}

export const ConsentFooter = ({ consentFooter }: ConsentFooterProps) => {
  if (consentFooter?.links?.length) {
    return (
      <Text color='fg/moderate' textAlign='center' textStyle='detail-s' display='block'>
        {renderTextWithLinks(consentFooter)}
      </Text>
    )
  }
  // Fallback to original behavior for backward compatibility
  return (
    <Text
      as='a'
      target='_blank'
      href={rolloutFlags.chatConsentFooterLink?.getValue().toString()}
      color='fg/moderate'
      textAlign='center'
      fontSize={10}
      fontWeight={500}
      display='block'
    >
      {rolloutFlags.chatConsentFooter?.getValue()}
    </Text>
  )
}
